import { Tooltip } from 'antd';
import { TableProps } from 'antd/lib';
import { COLOR_TOOLTIP, DATA_EMPTY } from '@constants/common';
import { INVENTORY_REPORT_CONSTANT, TReportRow } from './constant';

const { TABLE_HEADER } = INVENTORY_REPORT_CONSTANT;

const renderTextTooltip = (
  value?: string | null,
  emptyFallback: string = DATA_EMPTY
) => {
  if (!value) {
    return emptyFallback;
  }
  return (
    <span className="inventory-report_ellipsis">
      <Tooltip
        color="white"
        overlayClassName="common_custom-tooltip"
        title={value}
        overlayInnerStyle={{ color: COLOR_TOOLTIP }}
      >
        {value}
      </Tooltip>
    </span>
  );
};

// [6.2] Report Table — 10 cột theo 画面項目一覧 (analyzing-fe.md §2.5), sort mặc định 資産番号 tăng.
export const getColumns = (): TableProps<TReportRow>['columns'] => [
  {
    title: TABLE_HEADER.ASSET_CATEGORY,
    dataIndex: 'assetType',
    key: 'assetType',
    width: 110,
    align: 'right',
    render: (value: string | null) => value ?? DATA_EMPTY,
  },
  {
    title: TABLE_HEADER.ASSET_NO,
    dataIndex: 'assetNo',
    key: 'assetNo',
    width: 90,
    align: 'left',
    sorter: (a, b) => (a.assetNo ?? '').localeCompare(b.assetNo ?? ''),
    defaultSortOrder: 'ascend',
    render: (value: string | null) => value ?? DATA_EMPTY,
  },
  {
    title: TABLE_HEADER.ASSET_NAME,
    dataIndex: 'assetName',
    key: 'assetName',
    width: 220,
    align: 'left',
    render: (value: string | null) => renderTextTooltip(value),
  },
  {
    title: TABLE_HEADER.STORE,
    dataIndex: 'storeCode',
    key: 'storeCode',
    width: 100,
    align: 'center',
    render: (value: string | null) => value ?? DATA_EMPTY,
  },
  {
    title: TABLE_HEADER.ACQUISITION_DATE,
    dataIndex: 'acquisitionDate',
    key: 'acquisitionDate',
    width: 80,
    align: 'center',
    render: (value: string | null) => value ?? DATA_EMPTY,
  },
  {
    title: TABLE_HEADER.REMOVE_DATE,
    dataIndex: 'removeDate',
    key: 'removeDate',
    width: 100,
    align: 'center',
    render: (value: string | null) => value ?? DATA_EMPTY,
  },
  {
    title: TABLE_HEADER.ACQUISITION_COST,
    dataIndex: 'acquisitionCostDisplay',
    key: 'acquisitionCostDisplay',
    width: 105,
    align: 'right',
    render: (value: string | null) => value ?? DATA_EMPTY,
  },
  {
    title: TABLE_HEADER.QUANTITY,
    dataIndex: 'quantity',
    key: 'quantity',
    width: 70,
    align: 'right',
    render: (value: number | null) =>
      value === null || value === undefined ? DATA_EMPTY : value,
  },
  {
    title: TABLE_HEADER.REMARKS,
    dataIndex: 'remarks',
    key: 'remarks',
    width: 220,
    align: 'left',
    // Rỗng nếu null/"" — KHÔNG hiển thị "—" (khác các cột khác), theo 画面項目一覧 [6.2.9].
    // Ellipsis + hover hiện full text, giống 資産名称.
    render: (value: string | null) => renderTextTooltip(value, ''),
  },
];
